export var ServiceTemplateType = /*#__PURE__*/ function(ServiceTemplateType) {
    ServiceTemplateType["Service"] = "service";
    ServiceTemplateType["Bundle"] = "bundle";
    return ServiceTemplateType;
}({});
export var ServiceTemplateStatus = /*#__PURE__*/ function(ServiceTemplateStatus) {
    ServiceTemplateStatus["Active"] = "active";
    ServiceTemplateStatus["Deleted"] = "deleted";
    return ServiceTemplateStatus;
}({});
export var ServiceTemplateUsedIn = /*#__PURE__*/ function(ServiceTemplateUsedIn) {
    ServiceTemplateUsedIn["Draft"] = "draft";
    ServiceTemplateUsedIn["ProposalTemplate"] = "proposalTemplate";
    return ServiceTemplateUsedIn;
}({});
